import { useCallback } from 'react';
import { resetControlPanel } from 'redux/reducers/meteorologyAgroWBSequentialDVReducer';
import { store } from 'redux/store';

export default function useClearControlPanel() {
  const clearControlPanel = useCallback(() => {
    store.dispatch(resetControlPanel());
  }, []);

  return clearControlPanel;
}
